import axios from "axios";
import moment from "moment";

export const shouldShowLocation = (d) =>
  d._source.active && d._source.active === true && d._source.geo[0].length > 3;

export const transformLocation = (d, fetchGoogleImage = false) => {
  var newD = { ...d._source };
  newD.id = parseInt(d._id);
  d = d._source;
  newD.latitude = parseFloat(d.geo[0]);
  newD.longitude = parseFloat(d.geo[1]);
  newD.lat = parseFloat(d.geo[0]);
  newD.lng = parseFloat(d.geo[1]);
  newD.geo[0] = parseFloat(d.geo[0]);
  newD.geo[1] = parseFloat(d.geo[1]);

  //ALERTS
  var alerts = [];
  var today = moment();
  if (d.alerts.length > 0) {
    var start = new Date(d.alerts[0].ActivityStartDate);
    var end = new Date(d.alerts[0].ActivityEndDate);
    if (moment(today).isBetween(start, end)) {
      alerts[0] = d.alerts[0];
    }
  }
  for (let a of d.extra_alerts) {
    var start = new Date(a.ActivityStartDate);
    var end = new Date(a.ActivityEndDate);
    if (moment(today).isBetween(start, end)) {
      alerts.push(a);
    }
  }
  alerts.sort((a, b) => {
    var startA = new Date(a.ActivityStartDate);
    var startB = new Date(b.ActivityStartDate);
    return moment(startB).isSameOrAfter(startA);
  });

  delete newD.extra_alerts;
  newD.currentAlerts = alerts;

  //IMAGES
  newD.images = [];
  var getGoogleImages = false;
  if (d.hasOwnProperty("images") && d.images.length > 0) {
    if (d.images[0].main && d.images[0].main.filename) {
      var fn = d.images[0].main.filename.split(" ").join("%20");
      newD.image =
        "https://s3-us-west-2.amazonaws.com/htb-brc-public/assets/img/" + fn;
    }
    if (d.images.length < 2) {
      getGoogleImages = true;
      d.images[0].main.filename =
        "https://s3-us-west-2.amazonaws.com/htb-brc-public/assets/img/" + fn;
      newD.images.push(d.images[0]);
    } else {
      d.images.forEach((image) => {
        let fn = image.main.filename.split(" ").join("%20");
        image.main.filename =
          "https://s3-us-west-2.amazonaws.com/htb-brc-public/assets/img/" + fn;
        newD.images.push(image);
      });
    }
  } else {
    newD.image = "/images/defaultPhoto.png";
    getGoogleImages = true;
  }
  if (getGoogleImages && newD.id !== 600 && fetchGoogleImage) {
    axios
      .get("https://maps.googleapis.com/maps/api/streetview/metadata", {
        params: {
          location: newD.geo.join(),
          key: process.env.REACT_APP_GOOGLE_API_KEY
        }
      })
      .then(function (response) {
        if (response.status === 200 && response.data.status === "OK") {
          newD.images.push({
            main: {
              filename:
                "https://maps.googleapis.com/maps/api/streetview?size=640x426&heading=270&fov=110&location=" +
                newD.geo.join() +
                "&key=" +
                process.env.REACT_APP_GOOGLE_API_KEY
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  return newD;
};



// WEBPACK FOOTER //
// ./src/utils/locations.js